import React from "react";
import { motion } from "framer-motion";

// Line-by-line masked reveal for headings
export const RevealLines = ({ lines, className = "", delay = 0, testid }) => (
  <span data-testid={testid} className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs tracking-[0.28em] uppercase font-semibold ${
      light ? "text-white/60" : "text-royal"
    } ${className}`}
  >
    <span className={`h-px w-8 ${light ? "bg-white/40" : "bg-royal/40"}`} />
    {children}
  </span>
);
